import styled from 'styled-components';
import { rgba } from 'polished';

export const EditItemSC = styled.div<{ textColor: string; backgroundColor: string }>`
  width: 100%;
  height: 100%;
  border-radius: 3px;
  border: 1px solid transparent;
  background: transparent;
  display: flex;
  flex-direction: column;

  .item {
    height: 100%;
    border-radius: 3px;
    padding: 2px 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    color: ${({ textColor }) => textColor};
    background: ${({ backgroundColor }) => rgba(backgroundColor, 0.2)};
    border: 1px dashed ${({ backgroundColor }) => backgroundColor};
  }

  .item-wrapper {
    width: 100%;
    height: 100%;
    border: 1px solid transparent;
  }

  .empty-space {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    background: #d8d9e3;
    margin: 1px;

    svg {
      max-height: 70%;
      aspect-ratio: 1 / 1;
    }
  }
`;
